import {GrammarlyEditorPlugin} from '@grammarly/editor-sdk-react';
import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {useAppSelector} from '../../helpers/reduxHelpers';
import {getIsGrammarlyAllEnabled} from './grammarlySelectors';

/*
 * Props.
 */

interface GrammarlyEditorPluginWrapperProps {
  children: ReactNode;
  hasGrammarlySupport?: boolean;
}

/*
 * Style.
 */

const StyledGrammarlyEditorPlugin = styled(GrammarlyEditorPlugin)`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
`;

/*
 * Components.
 */

// Wrapper for GrammarlyEditorPlugin, used for adding the plugin to contentEditables, text fields, etc
export const GrammarlyEditorPluginWrapper: FC<GrammarlyEditorPluginWrapperProps> = ({
  children,
  hasGrammarlySupport,
}) => {
  const isGrammarlyAllEnabled = useAppSelector(getIsGrammarlyAllEnabled);

  if (!hasGrammarlySupport || !isGrammarlyAllEnabled) {
    return <>{children}</>;
  }
  return <StyledGrammarlyEditorPlugin>{children}</StyledGrammarlyEditorPlugin>;
};
